/*
 * Small helpers for the Agent Tracker. Times are always shown in IST, the
 * clock the agent plans on.
 */
import { CHANNELS } from "@/app-js/karrofin/constants";

/* What became of a planned message (GrowthPlannedSend.state). Status colours:
   reserved for these states, always shown with their label. */
export const STATE_COLORS = {
  planned: "#1976D2",
  sending: "#1976D2",
  sent: "#2E7D32",
  dropped: "#78909C",
  failed: "#C62828",
  expired: "#78909C",
  // A day the agent looked at them and sent nothing (not a planned message).
  skipped: "#78909C",
};

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** "2026-10-23" -> "23 Oct 2026". A plan day is already an IST date. */
export function dayIst(value) {
  const parts = String(value || "").split("-");
  if (parts.length !== 3) return value || "-";
  return `${Number(parts[2])} ${MONTHS[Number(parts[1]) - 1] || parts[1]} ${parts[0]}`;
}

let TIME_PARTS = null;
try {
  TIME_PARTS = new Intl.DateTimeFormat("en-IN", {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
} catch (e) {
  TIME_PARTS = null;
}

/** "2026-10-21T06:17:00+00:00" -> "11:47" (IST). */
export function timeIst(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "-";
  return TIME_PARTS ? TIME_PARTS.format(d) : d.toTimeString().slice(0, 5);
}

export function channelLabel(value) {
  const c = CHANNELS.find((x) => x.value === value);
  return c ? c.label : value || "-";
}

export function channelIcon(value) {
  const c = CHANNELS.find((x) => x.value === value);
  return c ? c.icon : "send";
}
